
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface CreatorProviderInfoProps {
  formData: any;
  onProviderChange: (value: string) => void;
}

export function CreatorProviderInfo({ formData, onProviderChange }: CreatorProviderInfoProps) {
  const { data: providers } = useQuery({
    queryKey: ["print-providers"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("print_service_providers")
        .select("*")
        .order("name");

      if (error) throw error;
      return data;
    },
  });

  return (
    <div className="flex items-center space-x-2">
      <Label htmlFor="default_provider" className="whitespace-nowrap">Default Provider:</Label>
      <Select
        value={formData.default_provider?.toString() || "none"}
        onValueChange={onProviderChange}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select a provider" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="none">None</SelectItem>
          {providers?.map((provider) => (
            <SelectItem key={provider.provider_id} value={provider.provider_id.toString()}>
              {provider.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
